import ContactComp from "../components/Contact/ContactComp";

export default function Contact () {

  return (
    <>
      <ContactComp />
    </>
  )
}